import { useTogglePlay } from '@/scenarios/legacy-player/hooks/useTogglePlay';

import { useActiveTabController } from '../../feature-player/hooks/controller/use-active-tab-controller';

export const useVodActiveTabController = () => {
    const { play, pause } = useTogglePlay();

    useActiveTabController({ play, pause });
};
